// extracted by mini-css-extract-plugin
export default {"response":"Response_response__2YLPg","title":"Response_title__1PCeZ","body":"Response_body__2x4IR"};